import { Component, Input } from '@angular/core'
import { ReplaySubject } from 'rxjs'
import { MediumContent } from './medium-content.interface'
import {
  hasVideoDescription,
  isEventWithStartDate,
  isEventWithPublishDate,
  showPreviewText
} from './medium-content.utility'
import { map } from 'rxjs/operators'

@Component({
  selector: 'flo-medium-content',
  templateUrl: './medium-content.component.html',
  styleUrls: ['./medium-content.component.scss']
})
export class MediumContentComponent {
  private readonly item$ = new ReplaySubject<MediumContent>(1)
  @Input() public title: string
  @Input() public thumbnail = false
  @Input() public desc = false
  @Input() public banner = false

  @Input()
  set item(value: any) {
    if (!!value) {
      this.item$.next(value)
    }
  }

  public props$ = this.item$.pipe(
    map((item: MediumContent) => {
      const dateToRender = item.publish_start_date || item.publish_date
      const modifiedDate = item.modified_at
      return {
        ...item,
        showPublishDate: isEventWithPublishDate(dateToRender, item.type),
        showEventDate: isEventWithStartDate(item.start_date, item.type),
        showEventDescription: showPreviewText(this.desc, item.preview_text),
        showVideoDescription: hasVideoDescription(this.desc, this.banner, item),
        isBanner: this.banner,
        dateToRender,
        modifiedDate
      }
    })
  )
}
